import type { CompensationLine } from '@/types/compensation';

/** Lowercases and strips diacritics (NFD decomposition, then drop the combining marks) so
 * "Étienne" matches a search for "etienne". */
const normalize = (value: string): string =>
    value.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export interface FilterLinesOptions {
    lines: CompensationLine[];
    search: string;
}

/**
 * Keeps only the lines whose display name, job title or manager name contains `search`,
 * case- and accent-insensitively. An empty (or whitespace-only) search matches everything.
 */
export const filterLines = ({ lines, search }: FilterLinesOptions): CompensationLine[] => {
    const normalizedSearch = normalize(search.trim());

    if (!normalizedSearch) {
        return lines;
    }

    return lines.filter((line) =>
        [line.displayName, line.jobTitle, line.managerName].some(
            (field) => field !== null && normalize(field).includes(normalizedSearch),
        ),
    );
};
